import React from "react";
import { SlidersHorizontal } from "lucide-react";

interface FilterRailProps {
  isOpen: boolean;
  count: number;
  onToggle: () => void;
}

const FilterRail: React.FC<FilterRailProps> = ({ isOpen, count, onToggle }) => {
  return (
    <aside
      className={`filter-rail${isOpen ? " is-open" : ""}`}
      data-filter-rail=""
    >
      <style>{railStyles}</style>
      <button
        type="button"
        className="filter-rail-btn H"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-label={
          isOpen
            ? "Close filters"
            : count > 0
              ? `Open filters — ${count} active`
              : "Open filters"
        }
      >
        <SlidersHorizontal size={18} strokeWidth={2.2} />
        {count > 0 && (
          <span className="filter-rail-count" aria-hidden="true">
            {count}
          </span>
        )}
      </button>
    </aside>
  );
};

const railStyles = `
.filter-rail {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 1039;
  transition: opacity 160ms ease, transform 200ms ease;
}
.filter-rail.is-open {
  opacity: 0;
  pointer-events: none;
  transform: translate(16px, -50%);
}
.filter-rail-btn {
  /* Half-pill shape: rounded on the left, flush against the right edge.
     Brand blue makes this read as a primary action, not a passive handle. */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 44px;
  height: 56px;
  padding: 0 12px 0 14px;
  border: 0;
  border-radius: 999px 0 0 999px;
  background: #0b57c8;
  color: #ffffff;
  cursor: pointer;
  box-shadow: -2px 0 10px rgba(11, 87, 200, 0.18),
    -6px 0 24px rgba(11, 87, 200, 0.10);
  transition: background 140ms ease, box-shadow 160ms ease, padding-right 180ms ease,
    width 180ms ease;
}
.filter-rail-btn:hover {
  background: #0a4dab;
  padding-right: 18px;
  width: 50px;
  box-shadow: -3px 0 14px rgba(11, 87, 200, 0.28),
    -8px 0 32px rgba(11, 87, 200, 0.14);
}
.filter-rail-btn:focus-visible {
  outline: 0;
  box-shadow: -2px 0 10px rgba(11, 87, 200, 0.18),
    0 0 0 3px rgba(11, 87, 200, 0.30);
}
/* Count badge — sits inline next to the icon as a chip, white pill on blue. */
.filter-rail-count {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #ffffff;
  color: #0b57c8;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.02em;
}
`;

export default FilterRail;
